import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { deltaStore, selectionStore } from "@/hooks";
import { PanelCard } from "@/components/common";
import DeltaButtonGroup from "./DeltaButtonGroup.vue";


/**
 * Displays trace delta information.
 */
const __default__ = {
  name: "TraceDeltas",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const inDeltaView = computed(() => deltaStore.inDeltaView);
const addedTraces = computed(() => deltaStore.addedTraces);
const removedTraces = computed(() => deltaStore.removedTraces);

/**
 * Selects an added trace.
 * @param id - The trace to select.
 */
function handleAddedSelect(id: string): void {
  selectionStore.selectTraceLink(addedTraces.value[id]);
}

/**
 * Selects a removed trace.
 * @param id - The trace to select.
 */
function handleRemovedSelect(id: string): void {
  selectionStore.selectTraceLink(removedTraces.value[id]);
}

return (_ctx: any,_cache: any) => {
  return (inDeltaView.value)
    ? (_openBlock(), _createBlock(_unref(PanelCard), {
        key: 0,
        title: "Trace Links",
        collapsable: "",
        borderless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(DeltaButtonGroup, {
            "is-traces": "",
            "delta-type": "added",
            items: addedTraces.value,
            onClick: handleAddedSelect
          }, null, 8, ["items"]),
          _createVNode(DeltaButtonGroup, {
            "is-traces": "",
            "delta-type": "removed",
            items: removedTraces.value,
            onClick: handleRemovedSelect
          }, null, 8, ["items"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})